import DataStore from "../../stores/dataStore.js";

function DerivedDataPublisher()
{
    // //////// private members
    var derivedDataDeriver = require('./derived-data-deriver.js');
    var interestedDatasets = {};

    // //////// public members
    this.register = function(derivedDatasetId, parameters){
        for (var i=0; i<parameters.data.length; ++i){
            var interestedDatasetId = parameters.data[i].datasetId;
            if (!interestedDatasets[interestedDatasetId]){
                interestedDatasets[interestedDatasetId] = {};
            }
            interestedDatasets[interestedDatasetId][derivedDatasetId] = parameters;
        }
    }

    this.deregister = function(derivedDatasetId){
        for (var interestedDatasetId in interestedDatasets){
            for (var targetDerivedDatasetId in interestedDatasets[interestedDatasetId]){
                if (targetDerivedDatasetId === derivedDatasetId){
                    delete interestedDatasets[interestedDatasetId][targetDerivedDatasetId];
                    if ($.isEmptyObject(interestedDatasets[interestedDatasetId])){
                        delete interestedDatasets[interestedDatasetId];
                    }
                }
            }
        }
    }

    this.update = function(interestedDatasetId){
        var derivedData =  interestedDatasets[interestedDatasetId];
        for (var derivedDatasetId in derivedData){
            var parameters = derivedData[derivedDatasetId];
            var inputData = getInputData(parameters);
            var derivedData = derivedDataDeriver.derive(inputData, parameters, derivedDatasetId);
            if (derivedData[0] != null){
                DataStore.store(derivedDatasetId, derivedData[0]);
            }
        }

        function getInputData(parameters){
            var inputData = {};
            for (var i=0; i<parameters.data.length; ++i){
                var datasetId = parameters.data[i].datasetId;
                var latestData = DataStore.get(datasetId);
                inputData[datasetId] = [latestData];
            }

            return inputData;
        }
    }
}

module.exports = new DerivedDataPublisher();



// WEBPACK FOOTER //
// ./src/core/services/data-service/derived-data-updater.js